import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { Getter } from "vuex-class";

import CrudGrid from '@/../bower_components/teknisavuecomponents/components/grids/CrudGrid.vue';
import TkVisualizer from '@/../bower_components/teknisavuecomponents/components/document/TkVisualizer/TkVisualizer.vue';

import HttpRequest from "@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest";
import Util from "@/../bower_components/teknisavuecomponents/assets/utils/Util";
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';
import FileUtils from "@/../bower_components/teknisavuecomponents/assets/utils/FileUtils";
import SnackbarUtils from "@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils";
import { OcorrenciaController, OcorrenciaAprovacao } from "@/assets/ts/controller/OcorrenciaController";
import AprovacaoOcorrenciaPopup from '@/components/AprovacaoOcorrenciaPopup/AprovacaoOcorrenciaPopup.vue';
import UtilPG from '@/assets/ts/utils/Util';
import DadosVinculoPopup from '@/components/DadosVinculoPopup/DadosVinculoPopup.vue';
import { ActionPermissao, ControleAcessoController, ControleAcessoWrapper, ModuloPermissao } from "@/assets/ts/controller/ControleAcessoController";
import NovoMedicoPopup from "@/components/NovoMedicoPopup/NovoMedicoPopup.vue";

interface operation {
  save: (nrprogocorrencia: string) => Promise<any>,
  confirmation?: { title: string, message: string };
  messages?: { success?: string }
}

@Component({
  name: 'OcorrenciasPopup',
  components: {
    CrudGrid,
    TkVisualizer,
    AprovacaoOcorrenciaPopup,
    DadosVinculoPopup,
    NovoMedicoPopup
  }
})
class OcorrenciasPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ required: true })
  private readonly date: string;

  @Prop({ required: true })
  private readonly nrVinculo: number;

  @Prop({ default: 0 })
  private readonly triggerReload: number;

  @Prop({ default: false })
  private readonly value: boolean;

  private showDadosVinculo = false;

  private numeroVinculo?: number = 0;
  // #endregion

  // #region [ STORE ]
  @Getter('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtual: any;
  // #region [ EVENTS ]
  @Emit('input')
  private emitInput(show: boolean) {}
  // #endregion

  // #region [ DATA ]

  
  private showAprovaOcorrenciaPopup = false;
  
  public showNovoMedicoPopup = false;

  private readonly APROVAROCORRENCIAOPERATION = 'APROVAR';

  private readonly REPROVAROCORRENCIAOPERATION = 'REJEITAR';

  private minGatilho = '00:00';

  private ocorrenciaAprovacao: OcorrenciaAprovacao = {
    NRPROGOCORRENCIA: null,
    NRVINCULOM: null,
    NMVINCULOM: null,
    NRTIPOPROGOCORRENCIA: null,
    NRMOTIVOOCORFREQ: null,
    DTINICIOPROGOCOR: null,
    IDDIASSEMANA: null
  };

  private operations = {
    APROVAR: {
      save: OcorrenciaController.aprovaOcorrencia,
      confirmation: {
        title: 'Aprovar Ocorrência',
        message: 'Deseja realmente aprovar a ocorrência?',
      },
      messages: {
        success: 'Ocorrência aprovada com sucesso.',
      },
    },
    REJEITAR: {
      save: this.reprovaOcorrencia,
      confirmation: {
        title: 'Rejeitar Ocorrência',
        message: 'Deseja realmente rejeitar a ocorrência?',
      },
      messages: {
        success: 'Ocorrência rejeitada com sucesso.',
      },
    },
  };

  private operationsMessages = {
    invalid: 'Operação inválida.',
    operationNotAvailable: 'Opção não disponível',
  };

  /* Modos de operação considerando a opcao do operador poder alterar dados ou nao */
  private operationModes = {
    userCanEditCurrentPeriodo: 'userCanNotEditCurrentPeriodo',
    userCanNotEditCurrentPeriodo: 'userCanEditCurrentPeriodo',
  };

  private fieldItems = {
    NMDIAGNOST: [],
  };

  private medicos: any[] = [];

  private routeOcorrencia = 'getOcorrenciasDia';

  private fileBase64 = '';

  private loading = false;

  private get columns() {
    return [
      {
        text: 'Início Ocorrência',
        value: 'DTINICIOPROGOCOR',
        name: 'DTINICIOPROGOCOR',
        cols: 3,
        tag: 'TkDate',
        required: true,
        showOnList: true,
        showOnForm: true,
        hint: 'Data Inicial da Ocorrencia',
        readonly: true,
        readonlyField: true
      },
      {
        text: 'Dias Ocorrência',
        value: 'DIAOCORRE',
        type: 'number',
        cols: 3,
        defaultValue: '1',
        tag: 'v-text-field',
        required: false,
        showOnList: false,
        showOnForm: true,
        readonlyField: true,
        readonly: true
      },
      {
        text: 'Fim Ocorrência',
        value: 'DTFIMPROGOCOR',
        type: 'text',
        cols: 3,
        tag: 'TkDate',
        required: false,
        showOnForm: true,
        readonly: true
      },
      {
        text: 'Situação',
        value: 'DSCONFIRM',
        valueField: 'IDPROGOCORCONFIRMADA',
        descriptionField: "DSCONFIRM",
        readonly: true,
        defaultValue: {IDPROGOCORCONFIRMADA: 'P', DSCONFIRM: 'Pendente' },
        type: 'text',
        cols: 3,
        tag: 'TkSelect',
        hint: 'Situacao da ocorrencia',
        items: [
          {IDPROGOCORCONFIRMADA: 'S', DSCONFIRM: 'Confirmada' },
          {IDPROGOCORCONFIRMADA: 'N', DSCONFIRM: 'Rejeitada' },
          {IDPROGOCORCONFIRMADA: 'P', DSCONFIRM: 'Pendente' }
        ]
      },
      {
        text: 'Tipo do Dia',
        cols: 6,
        value: 'IDTIPODIACALENDARIO',
        type: 'text',
        tag: 'TkSelect',
        showOnList: false,
        valueField: 'IDTIPODIACALENDARIO',
        descriptionField: 'DSTIPODIACALENDARIO',
        items: [
          {
            DSTIPODIACALENDARIO: 'Feriado',
            IDTIPODIACALENDARIO: 'FERIADO',
          },
          {
            DSTIPODIACALENDARIO: 'Ponto Facultativo',
            IDTIPODIACALENDARIO: 'PONTOFACULTATIVO',
          },
        ],
      },
      {
        text: 'Tipo do Horário',
        cols: 6,
        value: 'IDTIPOHORARIO',
        type: 'text',
        tag: 'TkSelect',
        showOnList: false,
        valueField: 'IDTIPOHORARIO',
        descriptionField: 'NMTIPOHORARIO',
        items: [
          {
            NMTIPOHORARIO: 'Folga',
            IDTIPOHORARIO: 'F',
          },
          {
            NMTIPOHORARIO: 'Compensado',
            IDTIPOHORARIO: 'C',
          },
          {
            NMTIPOHORARIO: 'Normal',
            IDTIPOHORARIO: 'N',
          },
          {
            NMTIPOHORARIO: 'Turno',
            IDTIPOHORARIO: 'T',
          },
        ],
      },
      {
        text: 'Motivo de Ocorrência',
        cols: 6,
        tag: 'TkSelect',
        value: 'DSMOTIVOOCORFREQ',
        valueField: "NRMOTIVOOCORFREQ",
        descriptionField: "DSMOTIVOOCORFREQ",
        route: "getMotivoOcorFreq",
        reloadOnCreation: true,
        filters: this.filtersOcorrencia,
        required: true,
        outData: {
          IDANEXOOBRIGATORIO: 'IDANEXOOBRIGATORIO',
        },
      },
      {
        text: 'Tipo de Ocorrência',
        cols: 6,
        tag: 'TkSelect',
        value: 'NMTIPOPROGOCORRENCIA',
        valueField: "NRTIPOPROGOCORRENCIA",
        descriptionField: "NMTIPOPROGOCORRENCIA",
        route: "getTpOcorrencia",
        reloadOnCreation: true,
        filters: this.filtersOcorrencia,
        change: this.setSituacao,
        required: true
      },
      {
        text: 'Horário',
        cols: 6,
        tag: 'TkSelect',
        autocomplete: true,
        value: 'NRHORDIAM',
        valueField: 'NRHORDIAM',
        descriptionField: 'NMHORDIAH',
        route: 'getHoradiah',
        filters: this.filtersOcorrencia,
        reloadOnCreation: true,
        showOnList: false,
      },
      {
        text: 'Mínimo Horas',
        cols: 3,
        value: 'QTMINIMAPROGOCOR',
        type: 'text',
        tag: 'v-text-field',
        mask: '##:##',
        showOnList: false,
        change: (row: any) => this.formatHours(row, 'QTMINIMAPROGOCOR')
      },
      {
        text: 'Máximo Horas',
        cols: 3,
        value: 'QTMAXIMAPROGOCOR',
        type: 'text',
        tag: 'v-text-field',
        mask: '##:##',
        showOnList: false,
        change: (row: any) => this.formatHours(row, 'QTMAXIMAPROGOCOR')
      },
      {
        text: 'Doença',
        cols: 12,
        tag: 'TkSelect',
        autocomplete: true,
        value: 'CDDIAGNOST',
        valueField: "CDDIAGNOST",
        descriptionField: "NMDIAGNOST_VIEW",
        items: this.fieldItems.NMDIAGNOST,
        showOnList: false,
        change: this.doencaOnChange,
      },
      {
        text: 'Médico/Dentista',
        cols: 12,
        tag: 'TkSelect',
        autocomplete: true,
        value: 'NRPESSOA',
        valueField: "NRPESSOA",
        descriptionField: "NMPESSOA_VIEW",
        items: this.medicos,
        filters: this.filtersOcorrencia,
        showOnList: false,
        addButton: true,
        addButtonIcon: 'mdi-plus',
        addButtonClick: () => this.openNovoMedicoPopup(),
      },
      {
        text: 'Situação de Frequência do Gatilho',
        cols: 12,
        tag: 'TkSelect',
        autocomplete: true,
        value: 'NRSITUFREQGATILHO',
        valueField: "NRSITUFREQGATILHO",
        descriptionField: "DSSITUFREQUENCIA_VIEW",
        route: "getSituFrequencias",
        reloadOnCreation: true,
        filters: this.filtersOcorrencia,
        showOnList: false,
      },
      {
        text: 'Qtd. Mínima do Gatilho',
        cols: 4,
        value: 'QTMINGATILHOPROGOCOR',
        type: 'text',
        tag: 'v-text-field',
        mask: '##:##',
        showOnList: false,
        change: (row: any) => this.formatHours(row, 'QTMINGATILHOPROGOCOR')
      },
      {
        text: 'Qtd. Máxima do Gatilho',
        cols: 4,
        value: 'QTMAXGATILHOPROGOCOR',
        type: 'text',
        tag: 'v-text-field',
        mask: '##:##',
        showOnList: false,
        change: (row: any) => this.formatHours(row, 'QTMAXGATILHOPROGOCOR')
      },
      {
        text: 'Vr. Coeficiente de Acres. (%)',
        value: 'VRCOEFICIENTEACRESCIMO',
        type: 'text',
        cols: 4,
        tag: 'v-text-field',
        showOnList: false,
        change: (row: any) => this.formatFloat(row, 'VRCOEFICIENTEACRESCIMO')
      },
      {
        text: 'Observação',
        value: 'DSOBSERVACAO',
        type: 'text',
        cols: 12,
        tag: 'v-text-field'
      },
      {
        text: 'Documento',
        value: 'ANEXO',
        type: 'file',
        cols: 12,
        tag: 'v-file-input',
        readonlyField: true,
        showOnList: false,
        required: (row: any) => row.IDANEXOOBRIGATORIO === 'S',
      },
      {
        text: 'Incluído em',
        value: 'DTINCLUSAO',
        name: 'DTINCLUSAO',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        readonly: true,
        showOnList: false,
        showOnForm: (row) => !row.__is_new,
      },
      {
        text: 'Incluído por',
        value: 'NMOPERINCLUSAO',
        name: 'NMOPERINCLUSAO',
        cols: 6,
        tag: 'v-text-field',
        required: false,
        readonly: true,
        showOnList: false,
        showOnForm: (row) => !row.__is_new,
      },
      {
        text: 'Org. Inclusão',
        value: 'NRORGINCLUSAO',
        type: 'number',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        readonly: true,
        showOnList: false,
        showOnForm: (row) => !row.__is_new,
      },
      {
        text: 'Atualizado em',
        value: 'DTULTATU',
        name: 'DTULTATU',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        readonly: true,
        showOnList: false,
        showOnForm: (row) => !row.__is_new,
      },
      {
        text: 'Atualizado por',
        value: 'NMOPERULTATU',
        name: 'NMOPERULTATU',
        cols: 6,
        tag: 'v-text-field',
        required: false,
        readonly: true,
        showOnList: false,
        showOnForm: (row) => !row.__is_new,
      },
      {
        text: 'Org. Atualização',
        value: 'NRORGULTATU',
        type: 'number',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        readonly: true,
        showOnList: false,
        showOnForm: (row) => !row.__is_new,
      },
    ];
  }

  private nameRow: string = "Ocorrência";

  private showDialog: boolean = false;

  private triggerReloadTable = 0;

  private readonly PopUpButtonsOcorrencia = [
    {
      mode: 'edit',
      name: 'Salvar',
      label: 'Salvar',
      action: this.salvarOcorrencia
    }
  ];

  private actionsOcorrencia = [
    'view',
    {
      name: 'Aprovar',
      value: 'aprovar',
      icon: 'mdi-check',
      action: ControleAcessoWrapper.atualizar(this.aprovarOcorrencia),
      mode: 'view',
      condition: this.operadorAprovaOcorrencias,
    },
    {
      name: 'Rejeitar',
      value: 'rejeitar',
      icon: 'mdi-close',
      action: ControleAcessoWrapper.atualizar(this.rejeitarOcorrencia),
      mode: 'view',
      condition: this.operadorAprovaOcorrencias,
    },
    'edit',
    'delete',
    {
      name: 'Salvar',
      value: 'save',
      icon: 'mdi-content-save',
      action: this.salvarOcorrencia,
      mode: 'edit',
    },
    {
      name: 'Ver Arquivo',
      value: 'viewFile',
      icon: 'mdi-file-eye',
      action: this.viewFile,
      mode: 'view',
      condition: this.ocorrenciaHasFile,
    },
    'cancel',
    {
      name: 'Dados do Vínculo',
      value: 'dadosVinculo',
      icon: 'mdi-account',
      action: this.viewDadosVinculo,
      mode: 'view',
    },
  ];

  private toolbarActionsOcorrenciaOptions = {
    [this.operationModes.userCanEditCurrentPeriodo]: [
      'reload',
      'addPopUp',
    ],
    [this.operationModes.userCanNotEditCurrentPeriodo]: [
      'reload',
    ],
  };

  private get toolbarActionsOcorrencia() {
    return this.toolbarActionsOcorrenciaOptions[this.currentOperationMode];
  };

  private visualizer = {
    show: false,
    base64: '',
    mimeType: '',
    fileName: '',
  };
  //#endregion

  // #region [ COMPUTED ]
  private get user() {
    return this.$store.getters.user;
  }

  private get filtersOcorrencia() {
    if (!this.user) {
      return null;
    }

    const filters = {
      NRORG: this.user.nrorg,
      DTINICIOPROGOCOR: this.date,
      NRVINCULOM: this.nrVinculo,
      CDOPERADOR: this.user.cdoperador,
    };

    return filters;
  }

  private get defaultRow() {
    const row = {
      DTINICIOPROGOCOR: this.date,
      DTFIMPROGOCOR: this.date,
      DIAOCORRE: 1,
      __mode: 'edit',
      __is_new: true,
    };

    return row;
  };

  private get dialogTitle(): string {
    const title = `Ocorrências - ${this.date}`;

    return title;
  }

  private get canUserEditCurrentPeriodo(): boolean {
    return this.$store.getters.canUserEditCurrentPeriodo;
  }

  private get currentOperationMode() {
    return this.canUserEditCurrentPeriodo ? this.operationModes.userCanEditCurrentPeriodo : this.operationModes.userCanNotEditCurrentPeriodo;
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.showDialog = this.value;
  }

  @Watch('triggerReload')
  private triggerReloadOnChange() {
    this.reloadGrid();
  }
  // #endregion



  //#region [ LIFECYCLE ]
  created(): void {
    this.carregarMedicos();
  }
  //#endregion



  // #region [ METHODS ]
  private async salvarOcorrencia(currentRow: any){

    if(currentRow.__is_new) {
      ControleAcessoController.validarPermissao(ActionPermissao.IDCRIAR, ModuloPermissao.MODULO_OCORRENCIAS);
    } else {
      ControleAcessoController.validarPermissao(ActionPermissao.IDATUALIZAR, ModuloPermissao.MODULO_OCORRENCIAS);
    }

    if (Util.verifyRequired(currentRow, this.columns)) {

      if (!this.salvarOcorrenciaBeforeInsert(currentRow)) {
        return;
      }

      const fileBase64 = currentRow.ANEXO ?
        await this.createBase64File(currentRow.ANEXO) :
        null;

      const fileName = currentRow.ANEXO ?
        currentRow.ANEXO.name :
        null;
      
      if (!currentRow.CDDIAGNOST) {
        currentRow.CDTABECDI = null;
      }

      const params = {
        requestType: 'Row',
        row: {
          ...currentRow,
          FILE: fileBase64,
          NMFILE: fileName,
          CDOPERADOR: this.user.cdoperador,
          NRORG: this.user.nrorg,
          NRVINCULOM: this.nrVinculo,
        },
      };

      HttpRequest.post('setOcorrenciaFreq', params).then( (res) => {
        if(res.data.dataset && res.data.dataset.setOcorrenciaFreq.error){
          SnackbarUtils.showMessage(res.data.dataset.setOcorrenciaFreq.error, SnackbarUtils.TYPE_ALERT);
        }
        if(res.data.dataset && res.data.dataset.setOcorrenciaFreq.messages){
          SnackbarUtils.showMessage(res.data.dataset.setOcorrenciaFreq.messages[0].message, SnackbarUtils.TYPE_ALERT);
        }
        this.reloadGrid();
        SnackbarUtils.showMessage('Registro salvo com sucesso!', 'success');
      });
    }else{
      SnackbarUtils.showMessage('Verifique os campos obrigatórios.', 'error');
    }
  }

  private showActionOcorrencia(filter: any, row: any){
    const valoresSemEdicao = ['view', 'aprovar', 'rejeitar', 'viewFile'];
    if (this.canUserEditCurrentPeriodo) {
      return true;
    } else {
      if (valoresSemEdicao.includes(filter.value)) {
        return true;
      }
      return false;
    }
  }

  private async deletarOcorrencia(currentRow: any){
    ControleAcessoController.validarPermissao(ActionPermissao.IDDELETAR, ModuloPermissao.MODULO_OCORRENCIAS);

    const route = 'removeOcorrenciaFreq';

    const params = {
      requestType: 'Row',
      row: {
        NRORG: this.user.nrorg,
        NRVINCULOM: this.nrVinculo,
        ...currentRow,
      },
    };

    try {
      const response = await HttpRequest.post(route, params);

      if (typeof response.data === 'string') {
        throw new Error(response.data);
      }

      const message = 'Ocorrência excluída com sucesso!';
      SnackbarUtils.showMessage(message, 'success');
    } catch (err) {
      const errResponse = (err as any).response;
      const message = errResponse && errResponse.data ? errResponse.data.error : 'Não foi possível excluir a ocorrência.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);

      throw err;
    }
  }

  private closeOcorrenciaCard(){
    this.showDialog = false;

    this.emitInput(this.showDialog);
  }

  private reloadGrid() {
    this.triggerReloadTable++;
  }

  private setSituacao(currentRow: any){
    if (currentRow.IDPROGOCORACONFIRMAR === 'N') {
      currentRow.IDPROGOCORCONFIRMADA = 'S';
      currentRow.DSCONFIRM = 'Confirmada';
    } else {
      currentRow.IDPROGOCORCONFIRMADA = 'P';
      currentRow.DSCONFIRM = 'Pendente';
    }
  }

  private async createBase64File(file: File) {
    try {
      if (!file) {
        return '';
      }
      
      const fileString = await FileUtils.toBase64(file);
      return fileString;
    } catch (err) {
      const message = 'Não foi possível carregar o arquivo';
      SnackbarUtils.showMessage(message, 'alert', 5000);

      throw err;
    }
  }

  private async downloadFile(
    row: any,
  ) {
    const nrVinculo = this.nrVinculo.toString();
    const nrMarcacao = row.NRPROGOCORRENCIA;
    this.loading = true;

    try {
      await OcorrenciaController.downloadOcorrenciaFile(
        nrVinculo, nrMarcacao, this.date
      );
    } catch(err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  private hasFile(
    row: any,
  ): boolean {
    const ocorrenciaHasFile = !Util.isEmptyOrBlank(row.DSPATH);

    return ocorrenciaHasFile;
  }

  private ocorrenciaHasFile(row: any): boolean {
    return !!row.DSPATH;
  }

  private async viewFile(row: any) {
    const nrOcorrencia: string = row.NRPROGOCORRENCIA;

    this.loading = true;

    try {
      const fileData = await OcorrenciaController.getOcorrenciaFile(nrOcorrencia);
      const { base64, type } = fileData;

      const fullBase64 = FileUtils.getFullBase64(
        base64, type
      );

      const fileName = `ocorrencia_${this.nrVinculo}_${nrOcorrencia}`;

      this.visualizer.show = true;
      this.visualizer.base64 = fullBase64;
      this.visualizer.mimeType = type;
      this.visualizer.fileName = fileName;
    } finally {
      this.loading = false;
    }
  }

  private salvarOcorrenciaBeforeInsert(row) {
    // Validacao QTMAXIMA e QTMINIMA
    if (row.QTMAXIMAPROGOCOR && row.QTMINIMAPROGOCOR) {
      const qtMaxima =
      row.QTMAXIMAPROGOCOR ? (parseInt(row.QTMAXIMAPROGOCOR.replace(':', '')) ? parseInt(row.QTMAXIMAPROGOCOR.replace(':', '')) : 0) : 0;

      const qtMinima =
        row.QTMINIMAPROGOCOR ? (parseInt(row.QTMINIMAPROGOCOR.replace(':', '')) ? parseInt(row.QTMINIMAPROGOCOR.replace(':', '')) : 0) : 0;

      if (qtMinima > qtMaxima) {
        SnackbarUtils.showMessage('O mínimo de horas não pode ser maior que o máximo. Faça as alterações e tente novamente.', SnackbarUtils.TYPE_ALERT);
        return false;
      }
    }


    // Gatilho
    if (row.QTMAXGATILHOPROGOCOR && row.QTMINGATILHOPROGOCOR) {
      const qtMaximaGatilho =
      row.QTMAXGATILHOPROGOCOR ? (parseInt(row.QTMAXGATILHOPROGOCOR.replace(':', '')) ? parseInt(row.QTMAXGATILHOPROGOCOR.replace(':', '')) : 0) : 0;
  
      const qtMinimaGatilho =
        row.QTMINGATILHOPROGOCOR ? (parseInt(row.QTMINGATILHOPROGOCOR.replace(':', '')) ? parseInt(row.QTMINGATILHOPROGOCOR.replace(':', '')) : 0) : 0;
  
      if (qtMinimaGatilho > qtMaximaGatilho) {
        SnackbarUtils.showMessage('O mínimo de horas do gatilho não pode ser maior que o máximo. Faça as alterações e tente novamente.', SnackbarUtils.TYPE_ALERT);
        return false;
      }
    }

    if(row.VRCOEFICIENTEACRESCIMO) {
      row.VRCOEFICIENTEACRESCIMO = this.parseFloatValue(row.VRCOEFICIENTEACRESCIMO);
    }

    return true;
  }

  private async crudGridAfterReload() {
    // Request doencas
    if (!this.fieldItems.NMDIAGNOST || (Array.isArray(this.fieldItems.NMDIAGNOST) && this.fieldItems.NMDIAGNOST.length === 0)) {
      try {
        const response = await HttpRequest.get('getDiagnost', {
          requestType: 'FilterData',
          NRORG: this.user.nrorg,
        }, false);
  
        if (typeof response.data === 'string') {
          throw new Error(response.data);
        }

        this.fieldItems.NMDIAGNOST = response.data.dataset.data;
      } catch (err) {
        const message = 'Houve um problema ao carregar informações de doença';
        SnackbarUtils.showMessage(message, 'error');
  
        throw err;
      }
    }
  }

  private async carregarMedicos() {
    try {
      const route = 'getPessoaConselhoReg';
      const params = {
        requestType: 'FilterData',
        ...this.filtersOcorrencia
      };

      const response = await HttpRequest.get(route, params, false);

      if (response.data && response.data.dataset) {
        this.medicos = response.data.dataset.data || response.data.dataset[route] || [];
      }
    } catch (error) {
      console.error('Erro ao carregar médicos:', error);
      SnackbarUtils.showMessage('Erro ao carregar lista de médicos', 'error');
    }
  }

  // Rotina necessaria pois eh necessario manipular os dados do campo NMDIAGNOST
  private doencaOnChange(row) {
    const CIDData = this.fieldItems.NMDIAGNOST;
    const rowCDDIAGNOST = row.CDDIAGNOST;
    if (!rowCDDIAGNOST) {
      return;
    }
    
    const doencaData = CIDData.find((item) => item.CDDIAGNOST === rowCDDIAGNOST);
    if (!doencaData) {
      row.CDTABECDI = null;
      return;
    }
    
    row.CDTABECDI = doencaData.CDTABECDI;
  }

  public operadorIsDP(): boolean {
    const isDP = this.user.dp;

    return isDP;
  }

  private operadorAprovaOcorrencias(row:any) {
    return row.IDPROGOCORCONFIRMADA == 'P' && (this.operadorIsDP() || row.ID_OPER_APROVA_OCOR === 'S');
  }

  private getCurrentOperation(operationName: string): operation {
    const operations = Object.keys(this.operations);
    const currentOperation: string = operations.find((op: string) => op === operationName);
    const operation: operation = this.operations[currentOperation];

    if (!operation) {
      throw this.operationsMessages.invalid;
    }

    return operation;
  }

  private async alteraStatusOcorrencia(row: any, operationName: string) {
    const nrprogocorrencia = row.NRPROGOCORRENCIA;
    const operation = this.getCurrentOperation(operationName);

    if(this.$store.state.user.nrorg == 20 && 
        (!this.operadorIsDP() && this.$store.state.user.nrvinculom == row.NRVINCULOM)) {
      SnackbarUtils.showMessage(`Não é possível realizar ${operationName} para o seu próprio vínculo`, 'error');
      return;
    }

    if(operation.confirmation.title == 'Rejeitar Ocorrência') {
      this.reprovaOcorrencia(row);
    } else {
      await DialogUtils.show(operation.confirmation.title, operation.confirmation.message, async () => {
        this.requisitaAlteracaoStatusOcorrencia(row, operation);
      });
    }
  }

  private async requisitaAlteracaoStatusOcorrencia(row: any, operation: operation) {
    try {
      const nrprogocorrencia = row.NRPROGOCORRENCIA;
      await operation.save(nrprogocorrencia);

      SnackbarUtils.showMessage(operation.messages.success);
    } finally {
      this.reloadGrid();
    }
  }

  private async aprovarOcorrencia(row: any) {
    const operationName = this.APROVAROCORRENCIAOPERATION;

    await this.alteraStatusOcorrencia(row, operationName);
  }

  private async rejeitarOcorrencia(row: any) {
    const operationName = this.REPROVAROCORRENCIAOPERATION;

    await this.alteraStatusOcorrencia(row, operationName);
  }

  private formatFloat(row: any, key: string) {
    const value = row[key];
    if(!value) return;

    let floatValue = parseFloat(value.replace(',', '.'));

    if (isNaN(floatValue)) floatValue = 0;

    row[key] = floatValue.toFixed(5).replace('.', ',');

    this.$nextTick(() => {
      const rowCopy = Util.deepCopy(row);
      row[key] = floatValue.toFixed(5).replace('.', ',');
      row = { ...rowCopy };
    });
  }

  private parseFloatValue(value: string) {
    if(!value) return;
  
    const floatValue = parseFloat(value.replace(',', '.'));
  
    if (isNaN(floatValue)) return 0;
    
    return floatValue;
  }

  private formatHours(row: string, key: string) {
    const value = row[key];

    // Formata a saída como "HH:MM"
    const horas = UtilPG.formatHours(value);
    row[key] = horas;
  }

  private async reprovaOcorrencia(row: any) {
    const ocorrenciaAprovacao: OcorrenciaAprovacao = {
      ...row,
      IDAPROVACAO: 'R',
    };

    this.showAprovacaoOcorrenciaPopup(ocorrenciaAprovacao);
  }

  private showAprovacaoOcorrenciaPopup(ocorrencia: OcorrenciaAprovacao) {
    this.ocorrenciaAprovacao = { ...ocorrencia };
    this.showAprovaOcorrenciaPopup = true;
  }

  private aprovacaoOcorrenciaOnClose() {
    this.reloadGrid();
    return true;
  }


  private viewDadosVinculo(row: any) {
    try { 
      this.numeroVinculo = parseInt(row.NRVINCULOM, 10);
      this.showDadosVinculo = true;
      this.loading = false;
    } catch (err) {
      let message = '';
      let err2 = err as any;

      if (err2.name === 'ExpectedError') {
        message = err2.message;
        message = message.replace('(HCMSERVICES) ', '');
      } else {
        message = 'Não foi possível carregar os Dados do Vínculo!';
      }

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }
  }

  private openNovoMedicoPopup() {
    this.showNovoMedicoPopup = true;
  }

  public async medicoAfterSave(medico: any) {
    try {
      // Recarregar a lista de médicos
      await this.carregarMedicos();
      
      SnackbarUtils.showMessage(`Médico "${medico.NMPESSOA}" cadastrado com sucesso!`, 'success');
      
    } catch (error) {
      console.error('Erro ao atualizar lista de médicos:', error);
      SnackbarUtils.showMessage('Erro ao atualizar lista de médicos após cadastro.', 'error');
    }
  }
  //#endregion
}

export default OcorrenciasPopup;